import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26502df2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-logo rounded-full" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.replaceStack(_ctx.url, 'logo'),
      alt: `${_ctx.name} Logo`
    }, null, 8, _hoisted_2)
  ]))
}